import ItemCardBadge from '@/components/GridItemCard/Card/components/ItemCardBadge/ItemCardBadge';
import ItemCardSaveIcon from '@/components/GridItemCard/Card/components/ItemCardSaveIcon/ItemCardSaveIcon';

import { CardImageGrid, StyledCardImage, StyledFavoriteButton } from './CardImageStyles';

export type CardImageProps = {
    enterLinkHoverState: () => void;
    isMobile: boolean;
    itemId: number;
    leaveLinkHoverState: () => void;
    showBidStatus: boolean;
};

const CardImage = ({ enterLinkHoverState, isMobile, itemId, leaveLinkHoverState, showBidStatus }: CardImageProps) => {
    return (
        <StyledCardImage
            data-testid="image-container"
            onMouseEnter={enterLinkHoverState}
            onMouseLeave={leaveLinkHoverState}
        >
            <ItemCardBadge
                allowBidding
                itemId={itemId}
                myItemsSavedItemCard={isMobile}
                savedItemsCard
            />
            <StyledFavoriteButton>
                <ItemCardSaveIcon itemId={itemId} />
            </StyledFavoriteButton>
            <CardImageGrid
                alignBannerBottomWithGap
                itemId={itemId}
                shouldGiveRangeForMobileSize={isMobile}
                showBidStatus={showBidStatus}
                useInFluidGrid
            />
        </StyledCardImage>
    );
};

export default CardImage;
